"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Base_1 = __importDefault(require("./Base"));

var Base_2 = __importDefault(require("../Button/Base"));

var Search_1 = __importDefault(require("../icons/Search"));

var Close_1 = __importDefault(require("../icons/Close"));

var SearchBarWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 56px;\n  position: relative;\n  width: 100%;\n\n  svg {\n    color: ", ";\n  }\n\n  .search__magnifyIcon {\n    position: absolute;\n    top: 20px;\n    left: 15px;\n  }\n"], ["\n  height: 56px;\n  position: relative;\n  width: 100%;\n\n  svg {\n    color: ", ";\n  }\n\n  .search__magnifyIcon {\n    position: absolute;\n    top: 20px;\n    left: 15px;\n  }\n"])), function (p) {
  return p.theme.color.neutral.v500;
});
var SearchInput = styled_components_1.default(Base_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n\n  input,\n  input.has-label {\n    padding-left: 38px;\n    padding-right: 56px;\n    min-width: 100%;\n  }\n\n  label {\n    left: 40px;\n  }\n"], ["\n  position: absolute;\n  width: 100%;\n\n  input,\n  input.has-label {\n    padding-left: 38px;\n    padding-right: 56px;\n    min-width: 100%;\n  }\n\n  label {\n    left: 40px;\n  }\n"])));
var ClearButton = styled_components_1.default(Base_2.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  min-width: 56px;\n  right: 0;\n  top: 0;\n"], ["\n  position: absolute;\n  min-width: 56px;\n  right: 0;\n  top: 0;\n"])));

var Search = function (_a) {
  var onChange = _a.onChange,
      innerRef = _a.innerRef,
      restProps = __rest(_a, ["onChange", "innerRef"]);

  return react_1.default.createElement(SearchBarWrapper, null, react_1.default.createElement(SearchInput, __assign({
    id: "search-bar",
    label: "Search",
    onChange: onChange,
    type: "search",
    ref: innerRef
  }, restProps)), react_1.default.createElement(Search_1.default, {
    className: "search__magnifyIcon"
  }), react_1.default.createElement(ClearButton, {
    onClick: onChange,
    "aria-label": "Clear Search"
  }, react_1.default.createElement(Close_1.default, null)));
};

exports.default = react_1.forwardRef(function (props, ref) {
  return react_1.default.createElement(Search, __assign({}, props, {
    innerRef: ref
  }));
});
var templateObject_1, templateObject_2, templateObject_3;